'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var cell = require('./cell-96115b74.js');

var HeaderRow = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, columns = _a.columns;
    return (React__default.createElement("tr", { "data-cy": dataCy && dataCy + "-headerRow", "data-testid": dataTestId && dataTestId + "-headerRow" }, columns.map(function (cell$1) { return (React__default.createElement(cell.Cell, { key: cell$1 === null || cell$1 === void 0 ? void 0 : cell$1.id, variant: "header", center: cell$1 === null || cell$1 === void 0 ? void 0 : cell$1.center, hidden: cell$1 === null || cell$1 === void 0 ? void 0 : cell$1.hidden }, cell$1 === null || cell$1 === void 0 ? void 0 : cell$1.label)); })));
};

exports.HeaderRow = HeaderRow;
